import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles, Trophy, X } from 'lucide-react';
import { humanizeFamilyId } from '../../content';
import { soundManager } from '../../utils/soundManager';
import { hapticManager } from '../../utils/hapticManager';
interface NewlyUnlockedBannerProps {
  familyId: string | null;
  onClick: () => void;
  onClose: () => void;
}
export function NewlyUnlockedBanner({
  familyId,
  onClick,
  onClose
}: NewlyUnlockedBannerProps) {
  // F-FEEL-9: celebrate the click — sound + haptic before opening the challenge
  const handleClick = () => {
    if (typeof soundManager.playStreak === 'function') {
      soundManager.playStreak();
    } else {
      soundManager.playClick();
    }
    hapticManager.hapticMedium();
    onClick();
  };
  return <AnimatePresence data-id="element-2811">
      {familyId && <motion.div initial={{
      opacity: 0,
      y: -20,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: -20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      bounce: 0.4,
      duration: 0.6
    }} className="relative z-10" data-id="element-2812">
          <button onClick={handleClick} className="w-full text-left bg-gradient-to-r from-amber-400 to-orange-500 p-1 rounded-2xl shadow-xl shadow-orange-500/20 hover:scale-[1.02] active:scale-[0.98] transition-transform" data-id="element-2813">
            <div className="bg-white rounded-xl p-4 flex items-center gap-4 relative overflow-hidden" data-id="element-2814">
              <div className="absolute -right-4 -top-4 text-orange-100 opacity-50 transform rotate-12" data-id="element-2815">
                <Trophy className="w-24 h-24" data-id="element-2816" />
              </div>

              <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0 relative z-10 shadow-sm" data-id="element-2817">
                <Trophy className="w-6 h-6 text-orange-500" data-id="element-2818" />
              </div>

              <div className="flex-1 relative z-10" data-id="element-2819">
                <div className="text-xs font-bold text-orange-500 uppercase tracking-wider mb-0.5 flex items-center gap-1" data-id="element-2820">
                  <Sparkles className="w-3 h-3" data-id="element-2821" />
                  Uitdaging ontgrendeld!
                </div>
                <div className="text-slate-800 font-medium text-sm md:text-base" data-id="element-2822">
                  Je hebt 70% gehaald voor{' '}
                  <span className="font-bold" data-id="element-2823">
                    {humanizeFamilyId(familyId)}
                  </span>
                  . Klik hier om te starten!
                </div>
              </div>

              <div onClick={e => {
            e.stopPropagation();
            onClose();
          }} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition-colors relative z-10" aria-label="Sluiten" data-id="element-2824">
                <X className="w-5 h-5" data-id="element-2825" />
              </div>
            </div>
          </button>
        </motion.div>}
    </AnimatePresence>;
}